<script>
export default {
  data() {
    return {}
  },
  methods: {
    menuSelect(index) {
      this.$router.push({
        name: index,
      })
    },
  },
}
</script>

<template>
  <div :class="[$style.affiliateNav]">
    <el-menu
      :default-active="$route.name"
      mode="horizontal"
      :class="[$style.elMenu]"
      @select="menuSelect"
    >
      <el-menu-item index="affiliate-balance">
        {{ $t('affiliate.list_allowance_balance_asset') }}
      </el-menu-item>
      <el-menu-item index="affiliate-log">
        {{ $t('affiliate.affiliate_occur_list') }}
      </el-menu-item>
      <el-menu-item index="affiliate-adjust">
        {{ $t('affiliate.affiliate_adjust_list') }}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.affiliateNav {
  margin-bottom: 20px;

  .elMenu {
    border-bottom: none;

    li {
      padding: 0 20px !important;
      margin-right: 10px;
      border: 1px solid #f0f0f0 !important;
      border-radius: 50px !important;

      @media (max-width: 768px) {
        height: 42px !important;
        padding: 0 20px !important;
        margin-top: 10px;
        font-size: 12px !important;
        line-height: 42px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-menu--horizontal > .el-menu-item.is-active {
  border: 1px solid #2a5cda !important;
  border-color: #2a5cda !important;
}
.el-menu {
  border: none !important;
}
</style>
